const warehouseHost = {
  development: 'https://playable.dev.com:8066',
  test: 'http://creative-api-test.mintegral.com',
  prerelease: 'https://pp-pre-api2.mintegral.com',
  production: 'https://creative-api.mintegral.com',
}

const ptHost = {
  development: 'https://playable.dev.com:8069/api',
  test: `/api`,
  prerelease: 'https://app-pre.playturbo.com/api',
  production: 'https://app.playturbo.com/api',
}

function getHostByEnv(env) {
  const isPtServer =
    ['playturbo', 've-pro', 'cloud-clip', 'ai'].indexOf(
      process.env.PROJECT_TYPE,
    ) > -1
  switch (env) {
    case 'production':
      return isPtServer ? ptHost.production : warehouseHost.production
    case 'prerelease':
      return isPtServer ? ptHost.prerelease : warehouseHost.prerelease
    case 'test':
      return isPtServer ? ptHost.test : warehouseHost.test
    default:
      return isPtServer ? ptHost.development : warehouseHost.development
  }
}

module.exports = {
  warehouseHost,
  ptHost,
  getHostByEnv,
}
